export function setMetaDataTypeJob(vacancy) {
  const container = getTagRobots()

  const value = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    "title": vacancy[1].name || '',
    "description": vacancy[3].about || '',
    "identifier": {
      "@type": "PropertyValue",
      "name": vacancy[3].work_place_name || '',
      "value": vacancy[3].work_place_code || ''
    },
    "datePosted": vacancy.created_at.slice(0, 10),
    "validThrough": vacancy[1].relevant ? vacancy[1].relevant.replace(' ', 'T') : '',
    "employmentType": "FULL_TIME",
    "hiringOrganization": {
      "@type": "Organization",
      "name": vacancy[3].work_place_name || ''
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": vacancy[3].work_place_address || '',
        "addressCountry": vacancy[3].work_place_country ? vacancy[3].work_place_country.name : ''
      }
    },
    "baseSalary": {
      "@type": "MonetaryAmount",
      "currency": vacancy[1].currency ? vacancy[1].currency.currency : '',
      "value": {
        "@type": "QuantitativeValue",
        ...getSalary(vacancy[1].salary_in_selected_currency),
        "unitText": getSalaryUnit(vacancy[1].salary_type)
      }
    }
  }

  container.innerHTML = JSON.stringify(value)
}


export function deleteMetaDataTypeJob() {
  const tag = document.getElementById('meta-data-type-job')
  if (tag) {
    tag.parentElement.removeChild(tag)
  }
}

function getTagRobots() {
  return document.getElementById('meta-data-type-job')
      || createTag()
}

function createTag() {
  const tag = document.createElement('script')
  tag.setAttribute('type', 'application/ld+json')
  tag.setAttribute('id', 'meta-data-type-job')
  document.head.appendChild(tag)
  return tag
}

function getSalary(salary) {
  if (!Array.isArray(salary)) {
    return {
      value: salary || ''
    }
  }

  return {
    minValue: salary[0],
    maxValue: salary[1],
  }
}

function getSalaryUnit(salaryType) {
  if (!salaryType) return ''

  switch (salaryType.id) {
    case 80:
      return 'HOUR'
    case 81:
      return 'DAY'
    case 82:
      return 'WEEK'
    case 83:
      return 'MONTH'
    case 84:
      return 'YEAR'
    default:
      return ''
  }
}
